import { ActionIcon, Popover } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { useState } from 'react';
import { AddOperationMenu } from '../newStep/AddOperationMenu';
import type { OperationParentContext } from '~/server/logic/steps/operation/types';

export function AddOperationPopover({
  testContentId,
  insertAfterOperationOrder,
  activePageAlias,
  parentStepOrder,
  parentStepId,
  operationId,
  parentContexts,
}: {
  testContentId: string;
  insertAfterOperationOrder: number;
  activePageAlias?: string;
  parentStepOrder: number;
  parentStepId?: string;
  operationId?: string;
  parentContexts?: OperationParentContext[];
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <Popover
      shadow="md"
      width={300}
      position="bottom"
      withArrow
      opened={isMenuOpen}
      onChange={setIsMenuOpen}
    >
      <Popover.Target>
        <ActionIcon
          title="Add Operation"
          onClick={() => setIsMenuOpen(true)}
          radius="xl"
          size={24}
          className="flex items-center justify-center bg-gray-700 hover:bg-gray-800 dark:bg-gray-700 dark:hover:bg-gray-500"
          aria-expanded={isMenuOpen}
          aria-haspopup="true"
        >
          <IconPlus size={14} />
        </ActionIcon>
      </Popover.Target>
      <Popover.Dropdown className="px-0 py-4">
        <AddOperationMenu
          testContentId={testContentId}
          parentStepId={parentStepId}
          operationId={operationId}
          insertAfterStepOrder={parentStepOrder}
          insertAfterOperationOrder={insertAfterOperationOrder}
          closePopover={() => setIsMenuOpen(false)}
          activePageAlias={activePageAlias}
          parentContexts={parentContexts}
        />
      </Popover.Dropdown>
    </Popover>
  );
}
